import React, { memo } from "react";
import { Link } from "react-router-dom";
import { StyledListItem } from "../../styled/layout";
import DrawerItemTooltip from "./drawerItemTooltip";

const ListItemComponent = ({ path, selected, title, icon: Icon, id, open }) => {
  return (
    <DrawerItemTooltip tooltipText={title} drawerOpen={open}>
      <StyledListItem.Nested
        itemSelected={selected}
        button
        component={Link}
        to={path}
        id={id}>
        <StyledListItem.Icon selected={selected}>{Icon}</StyledListItem.Icon>
        <StyledListItem.Text selected={selected}>{title}</StyledListItem.Text>
      </StyledListItem.Nested>
    </DrawerItemTooltip>
  );
};

export default memo(ListItemComponent);
